export default __webpack_public_path__ + "static/media/target.500f47f8.svg";